import React from "react";
import { shortDate } from "../../lib/format";

export interface ArchivedCase { id: string; title: string; intro?: string; published_at?: string; bottles?: number; wines: { product_handle: string; title: string; image?: string | null; vendor?: string | null; quantity?: number }[] }

export function PreviousCases({ items, tone = "var(--club-dark)" }: { items: ArchivedCase[]; tone?: string }) {
  if (!items.length) return null;
  return (
    <section className="mt-14" data-testid="previous-cases">
      <div className="eyebrow" style={{ color: tone }}>Looking back</div>
      <h2 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl">Previous cases</h2>
      <p className="mt-3 max-w-2xl text-sm text-neutral-600">Every quarter is different — a few of the cases members have opened recently.</p>
      <div className="mt-6 grid gap-6 lg:grid-cols-2">
        {items.map((c, i) => (
          <article key={c.id} className="border border-border bg-white p-5 rise" style={{ animationDelay: `${i * 80}ms` }} data-testid={`previous-case-${c.id}`}>
            <div className="flex flex-wrap items-baseline justify-between gap-2">
              <h3 className="font-serif text-xl" data-testid={`previous-case-title-${c.id}`}>{c.title}</h3>
              <span className="text-xs text-neutral-500">{c.published_at ? shortDate(c.published_at) : ""}{c.bottles ? ` · ${c.bottles} bottles` : ""}</span>
            </div>
            <ul className="mt-4 grid grid-cols-6 gap-2 sm:grid-cols-12">
              {c.wines.map((w) => (
                <li key={w.product_handle} className="aspect-[2/5] overflow-hidden bg-[var(--paper)]" title={w.title}>
                  {w.image ? <img src={w.image} alt={w.title} loading="lazy" className="h-full w-full object-cover" /> : null}
                </li>
              ))}
            </ul>
            <p className="mt-3 line-clamp-2 text-xs leading-relaxed text-neutral-600">{c.wines.map((w) => w.title).join(" · ")}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
